// PRODUCT/BLACKLIGHT
// Results
export const PRODUCT_RESULTS_UPLOAD_CONFIG_LOADED = 'PRODUCT_RESULTS_UPLOAD_CONFIG_LOADED';
export const PRODUCT_RESULTS_UPLOAD_CONFIG_CLEAR = 'PRODUCT_RESULTS_UPLOAD_CONFIG_CLEAR';
export const PRODUCT_RESULTS_INFRINGEMENTS_LOADED = 'PRODUCT_RESULTS_INFRINGEMENTS_LOADED';
export const PRODUCT_RESULTS_INFRINGEMENTS_CLEAR = 'PRODUCT_RESULTS_INFRINGEMENTS_CLEAR';
export const PRODUCT_RESULTS_INFRINGEMENTS_META_LOADED = 'PRODUCT_RESULTS_INFRINGEMENTS_META_LOADED';
export const PRODUCT_RESULTS_INFRINGEMENTS_META_CLEAR = 'PRODUCT_RESULTS_INFRINGEMENTS_META_CLEAR';
export const PRODUCT_RESULTS_REMOVALS_LOADED = 'PRODUCT_RESULTS_REMOVALS_LOADED';
export const PRODUCT_RESULTS_REMOVALS_CLEAR = 'PRODUCT_RESULTS_REMOVALS_CLEAR';
export const PRODUCT_RESULT_DETAIL_LOADED = 'PRODUCT_RESULT_DETAIL_LOADED';
export const PRODUCT_RESULT_DETAIL_CLEAR = 'PRODUCT_RESULT_DETAIL_CLEAR';

// Review
export const PRODUCT_REVIEW_DATA_LOADED = 'PRODUCT_REVIEW_DATA_LOADED';
export const PRODUCT_REVIEW_DATA_CLEAR = 'PRODUCT_REVIEW_DATA_CLEAR';
export const PRODUCT_REVIEW_STATS_LOADED = 'PRODUCT_REVIEW_STATS_LOADED';
export const PRODUCT_REVIEW_STATS_CLEAR = 'PRODUCT_REVIEW_STATS_CLEAR';
export const PRODUCT_REVIEW_META_LOADED = 'PRODUCT_REVIEW_META_LOADED';
export const PRODUCT_REVIEW_META_CLEAR = 'PRODUCT_REVIEW_META_CLEAR';

// Searches - New
export const PRODUCT_NEW_FORM_CONFIG_LOADED = 'PRODUCT_NEW_FORM_CONFIG_LOADED';
export const PRODUCT_NEW_FORM_CONFIG_CLEAR = 'PRODUCT_NEW_FORM_CONFIG_CLEAR';
export const PRODUCT_NEW_FORM_BULK_CONFIG_LOADED = 'PRODUCT_NEW_FORM_BULK_CONFIG_LOADED';
export const PRODUCT_NEW_FORM_BULK_CONFIG_CLEAR = 'PRODUCT_NEW_FORM_BULK_CONFIG_CLEAR';
export const PRODUCT_NEW_SEARCHES_USAGE_LOADING = 'PRODUCT_NEW_SEARCHES_USAGE_LOADING';
export const PRODUCT_NEW_SEARCHES_USAGE_LOADED = 'PRODUCT_NEW_SEARCHES_USAGE_LOADED';
export const PRODUCT_NEW_SEARCHES_USAGE_CLEAR = 'PRODUCT_NEW_SEARCHES_USAGE_CLEAR';
export const PRODUCT_NEW_SEARCHES_TEAMS_LOADED = 'PRODUCT_NEW_SEARCHES_TEAMS_LOADED';
export const PRODUCT_NEW_SEARCHES_TEAMS_CLEAR = 'PRODUCT_NEW_SEARCHES_TEAMS_CLEAR';

// Searches - List
export const PRODUCT_LIST_SEARCHES_LOADED = 'PRODUCT_LIST_SEARCHES_LOADED';
export const PRODUCT_LIST_SEARCHES_CLEAR = 'PRODUCT_LIST_SEARCHES_CLEAR';
export const PRODUCT_LIST_SEARCHES_ADDED_LOADED = 'PRODUCT_LIST_SEARCHES_ADDED_LOADED';
export const PRODUCT_LIST_SEARCHES_ADDED_CLEAR = 'PRODUCT_LIST_SEARCHES_ADDED_CLEAR';
export const PRODUCT_LIST_SEARCHES_META_LOADED = 'PRODUCT_LIST_SEARCHES_META_LOADED';
export const PRODUCT_LIST_SEARCHES_META_CLEAR = 'PRODUCT_LIST_SEARCHES_META_CLEAR';
export const PRODUCT_LIST_SEARCHES_STATS_LOADED = 'PRODUCT_LIST_SEARCHES_STATS_LOADED';
export const PRODUCT_LIST_SEARCHES_STATS_CLEAR = 'PRODUCT_LIST_SEARCHES_STATS_CLEAR';

// Searches - Dashboard
export const PRODUCT_DASHBOARD_SEARCH_RESULTS_LOADED = 'PRODUCT_DASHBOARD_SEARCH_RESULTS_LOADED';
export const PRODUCT_DASHBOARD_SEARCH_RESULTS_CLEAR = 'PRODUCT_DASHBOARD_SEARCH_RESULTS_CLEAR';
export const PRODUCT_DASHBOARD_SEARCH_RESULTS_META_LOADED = 'PRODUCT_DASHBOARD_SEARCH_RESULTS_META_LOADED';
export const PRODUCT_DASHBOARD_SEARCH_RESULTS_META_CLEAR = 'PRODUCT_DASHBOARD_SEARCH_RESULTS_META_CLEAR';

// Embeds
export const PRODUCT_OVERVIEW_ACCESS_DATA_LOADED = 'PRODUCT_OVERVIEW_ACCESS_DATA_LOADED';
export const PRODUCT_OVERVIEW_ACCESS_DATA_CLEAR = 'PRODUCT_OVERVIEW_ACCESS_DATA_CLEAR';
export const PRODUCT_REPORT_ACCESS_DATA_LOADED = 'PRODUCT_REPORT_ACCESS_DATA_LOADED';
export const PRODUCT_REPORT_ACCESS_DATA_CLEAR = 'PRODUCT_REPORT_ACCESS_DATA_CLEAR';

// COMPANY SETTINGS
export const COMPANY_SETTINGS_LOADED = 'COMPANY_SETTINGS_LOADED';
export const COMPANY_SETTINGS_CLEAR = 'COMPANY_SETTINGS_CLEAR';
export const COMPANY_SINGLE_SETTING_LOADED = 'COMPANY_SINGLE_SETTING_LOADED';
export const COMPANY_SINGLE_SETTING_CLEAR = 'COMPANY_SINGLE_SETTING_CLEAR';
export const COMPANY_NOTIFICATION_SETTINGS_LOADED = 'COMPANY_NOTIFICATION_SETTINGS_LOADED';
export const COMPANY_NOTIFICATION_SETTINGS_CLEAR = 'COMPANY_NOTIFICATION_SETTINGS_CLEAR';
export const COMPANY_MAINTENANCE_SETTINGS_LOADED = 'COMPANY_MAINTENANCE_SETTINGS_LOADED';
export const COMPANY_MAINTENANCE_SETTINGS_CLEAR = 'COMPANY_MAINTENANCE_SETTINGS_CLEAR';
export const COMPANY_UNITS_LOADED = 'COMPANY_UNITS_LOADED';
export const COMPANY_UNITS_CLEAR = 'COMPANY_UNITS_CLEAR';

// FINGERPRINTING CONFIG
export const FINGERPRINTING_CONFIG_LOADED = 'FINGERPRINTING_CONFIG_LOADED';
export const FINGERPRINTING_CONFIG_CLEAR = 'FINGERPRINTING_CONFIG_CLEAR';

// ANALYTICS ACTIONS
export const LIVE_TRACKER_ANALYTICS_DATA_LOADED = 'LIVE_TRACKER_ANALYTICS_DATA_LOADED';
export const LIVE_TRACKER_ANALYTICS_DATA_CLEAR = 'LIVE_TRACKER_ANALYTICS_DATA_CLEAR';
export const WATERMARK_DETECTIONS_LOADED = 'WATERMARK_DETECTIONS_LOADED';
export const WATERMARK_DETECTIONS_CLEAR = 'WATERMARK_DETECTIONS_CLEAR';

// CONTENT ID
// Assets
export const CONTENT_ID_ASSETS_LOADED = 'CONTENT_ID_ASSETS_LOADED';
export const CONTENT_ID_ASSETS_CLEAR = 'CONTENT_ID_ASSETS_CLEAR';
export const CONTENT_ID_ASSET_DETAILS_LOADED = 'CONTENT_ID_ASSET_DETAILS_LOADED';
export const CONTENT_ID_ASSET_DETAILS_CLEAR = 'CONTENT_ID_ASSET_DETAILS_CLEAR';
export const CONTENT_ID_ALLOWLIST_LOADED = 'CONTENT_ID_ALLOWLIST_LOADED';
export const CONTENT_ID_ALLOWLIST_CLEAR = 'CONTENT_ID_ALLOWLIST_CLEAR';
export const CONTENT_ID_ASSET_MATCH_POLICY_LOADED = 'CONTENT_ID_ASSET_MATCH_POLICY_LOADED';
export const CONTENT_ID_ASSET_MATCH_POLICY_CLEAR = 'CONTENT_ID_ASSET_MATCH_POLICY_CLEAR';

// Bulk Asset Uploads
export const CONTENT_ID_BULK_ASSET_REQUESTS_LOADED = 'CONTENT_ID_BULK_ASSET_REQUESTS_LOADED';
export const CONTENT_ID_BULK_ASSET_REQUESTS_CLEAR = 'CONTENT_ID_BULK_ASSET_REQUESTS_CLEAR';
export const CONTENT_ID_BULK_ASSET_REQUEST_STATUS_LOADED = 'CONTENT_ID_BULK_ASSET_REQUEST_STATUS_LOADED';
export const CONTENT_ID_BULK_ASSET_REQUEST_STATUS_CLEAR = 'CONTENT_ID_BULK_ASSET_REQUEST_STATUS_CLEAR';

// Claims
export const CONTENT_ID_CLAIMS_LOADED = 'CONTENT_ID_CLAIMS_LOADED';
export const CONTENT_ID_CLAIMS_CLEAR = 'CONTENT_ID_CLAIMS_CLEAR';
export const CONTENT_ID_CLAIM_DETAILS_LOADED = 'CONTENT_ID_CLAIM_DETAILS_LOADED';
export const CONTENT_ID_CLAIM_DETAILS_CLEAR = 'CONTENT_ID_CLAIM_DETAILS_CLEAR';
export const CONTENT_ID_CLAIM_HISTORY_LOADED = 'CONTENT_ID_CLAIM_HISTORY_LOADED';
export const CONTENT_ID_CLAIM_HISTORY_CLEAR = 'CONTENT_ID_CLAIM_HISTORY_CLEAR';
export const CONTENT_ID_MANUAL_CLAIM_REQUESTS_LOADED = 'CONTENT_ID_MANUAL_CLAIM_REQUESTS_LOADED';
export const CONTENT_ID_MANUAL_CLAIM_REQUESTS_CLEAR = 'CONTENT_ID_MANUAL_CLAIM_REQUESTS_CLEAR';
export const CONTENT_ID_MANUAL_CLAIM_REQUEST_DETAIL_LOADED = 'CONTENT_ID_MANUAL_CLAIM_REQUEST_DETAIL_LOADED';
export const CONTENT_ID_MANUAL_CLAIM_REQUEST_DETAIL_CLEAR = 'CONTENT_ID_MANUAL_CLAIM_REQUEST_DETAIL_CLEAR';
export const CONTENT_ID_CLAIM_RELEASE_REQUESTS_LOADED = 'CONTENT_ID_CLAIM_RELEASE_REQUESTS_LOADED';
export const CONTENT_ID_CLAIM_RELEASE_REQUESTS_CLEAR = 'CONTENT_ID_CLAIM_RELEASE_REQUESTS_CLEAR';
export const CONTENT_ID_CLAIM_RELEASE_REQUEST_DETAIL_LOADED = 'CONTENT_ID_CLAIM_RELEASE_REQUEST_DETAIL_LOADED';
export const CONTENT_ID_CLAIM_RELEASE_REQUEST_DETAIL_CLEAR = 'CONTENT_ID_CLAIM_RELEASE_REQUEST_DETAIL_CLEAR';
export const CONTENT_ID_CLAIMS_STATUS_PATCH = 'CONTENT_ID_CLAIMS_STATUS_PATCH';

// CYCLOPS
export const CYCLOPS_ORGANIZATIONS_DATA_LOADED = 'CYCLOPS_ORGANIZATIONS_DATA_LOADED';
export const CYCLOPS_ORGANIZATIONS_DATA_CLEAR = 'CYCLOPS_ORGANIZATIONS_DATA_CLEAR';
export const CYCLOPS_ACTIVE_ORGANIZATION_SET = 'CYCLOPS_ACTIVE_ORGANIZATION_SET';
export const CYCLOPS_ACTIVE_ORGANIZATION_CLEAR = 'CYCLOPS_ACTIVE_ORGANIZATION_CLEAR';
export const CYCLOPS_CONSTANTS_CONFIG_LOADED = 'CYCLOPS_CONSTANTS_CONFIG_LOADED';
export const CYCLOPS_CONSTANTS_CONFIG_CLEAR = 'CYCLOPS_CONSTANTS_CONFIG_CLEAR';
export const CYCLOPS_LIVESTREAMS_DATA_LOADED = 'CYCLOPS_LIVESTREAMS_DATA_LOADED';
export const CYCLOPS_LIVESTREAMS_DATA_CLEAR = 'CYCLOPS_LIVESTREAMS_DATA_CLEAR';
export const CYCLOPS_LIVESTREAM_DETAILS_LOADED = 'CYCLOPS_LIVESTREAM_DETAILS_LOADED';
export const CYCLOPS_LIVESTREAM_DETAILS_CLEAR = 'CYCLOPS_LIVESTREAM_DETAILS_CLEAR';
export const CYCLOPS_PIRACY_STREAMS_LOADED = 'CYCLOPS_PIRACY_STREAMS_LOADED';
export const CYCLOPS_PIRACY_STREAMS_CLEAR = 'CYCLOPS_PIRACY_STREAMS_CLEAR';
export const CYCLOPS_ANALYTICS_DATA_LOADED = 'CYCLOPS_ANALYTICS_DATA_LOADED';
export const CYCLOPS_ANALYTICS_DATA_CLEAR = 'CYCLOPS_ANALYTICS_DATA_CLEAR';
export const CYCLOPS_CDN_CONSTANTS_LOADED = 'CYCLOPS_CDN_CONSTANTS_LOADED';
export const CYCLOPS_CDN_CONSTANTS_CLEAR = 'CYCLOPS_CDN_CONSTANTS_CLEAR';
export const CYCLOPS_WATERMARKS_LOADED = 'CYCLOPS_WATERMARKS_LOADED';
export const CYCLOPS_WATERMARKS_CLEAR = 'CYCLOPS_WATERMARKS_CLEAR';

// PRODUCT AUTH
export const AUTH_LOG_IN = 'AUTH_LOG_IN';
export const AUTH_DEMO_LOG_IN = 'AUTH_DEMO_LOG_IN';
export const AUTH_LOG_OUT = 'AUTH_LOG_OUT';
export const AUTH_REFRESH = 'AUTH_REFRESH';
export const AUTH_ACCOUNT_LOADED = 'AUTH_ACCOUNT_LOADED';
export const AUTH_ACCOUNT_CLEAR = 'AUTH_ACCOUNT_CLEAR';
export const AUTH_USERS_LOADED = 'AUTH_USERS_LOADED';
export const AUTH_USERS_CLEAR = 'AUTH_USERS_CLEAR';
export const AUTH_INVITE_TOKEN_LOADED = 'AUTH_INVITE_TOKEN_LOADED';
export const AUTH_INVITE_TOKEN_CLEAR = 'AUTH_INVITE_TOKEN_CLEAR';

// PAYMENT SUBSCRIPTION
export const VERTICAL_TIERS_LOADED = 'VERTICAL_TIERS_LOADED';
export const VERTICAL_TIERS_CLEAR = 'VERTICAL_TIERS_CLEAR';
export const CUSTOMER_SUBSCRIPTION_LOADED = 'CUSTOMER_SUBSCRIPTION_LOADED';
export const CUSTOMER_SUBSCRIPTION_CLEAR = 'CUSTOMER_SUBSCRIPTION_CLEAR';
export const CUSTOMER_ONBOARDING_DATA_LOADING = 'CUSTOMER_ONBOARDING_DATA_LOADING';
export const CUSTOMER_ONBOARDING_DATA_LOADED = 'CUSTOMER_ONBOARDING_DATA_LOADED';
export const CUSTOMER_ONBOARDING_DATA_CLEAR = 'CUSTOMER_ONBOARDING_DATA_CLEAR';
export const ONBOARDING_PRICING_LOADED = 'ONBOARDING_PRICING_LOADED';
export const ONBOARDING_PRICING_CLEAR = 'ONBOARDING_PRICING_CLEAR';
export const ONBOARDING_SUBMISSION_SUCCESS = 'ONBOARDING_SUBMISSION_SUCCESS';
export const ONBOARDING_SUBMISSION_CLEAR = 'ONBOARDING_SUBMISSION_CLEAR';
export const ONBOARDING_PROVISIONING_SUCCESS = 'ONBOARDING_PROVISIONING_SUCCESS';
export const ONBOARDING_PROVISIONING_CLEAR = 'ONBOARDING_PROVISIONING_CLEAR';

// ADMIN
export const ADMIN_AUTH_LOG_IN = 'ADMIN_AUTH_LOG_IN';
export const ADMIN_AUTH_LOG_OUT = 'ADMIN_AUTH_LOG_OUT';
export const ADMIN_AUTH_REFRESH = 'ADMIN_AUTH_REFRESH';
export const ADMIN_AUTH_API_ERROR = 'ADMIN_AUTH_API_ERROR';
export const ADMIN_COMPANIES_LOADED = 'ADMIN_COMPANIES_LOADED';
export const ADMIN_COMPANIES_CLEAR = 'ADMIN_COMPANIES_CLEAR';
export const ADMIN_FILE_IMPORT_RESULT_LOADED = 'ADMIN_FILE_IMPORT_RESULT_LOADED';
export const ADMIN_FILE_IMPORT_RESULT_CLEAR = 'ADMIN_FILE_IMPORT_RESULT_CLEAR';
export const ADMIN_FILE_IMPORTS_LOADED = 'ADMIN_FILE_IMPORTS_LOADED';
export const ADMIN_FILE_IMPORTS_CLEAR = 'ADMIN_FILE_IMPORTS_CLEAR';
export const ADMIN_SEARCH_TYPES_LOADED = 'ADMIN_SEARCH_TYPES_LOADED';
export const ADMIN_SEARCH_TYPES_CLEAR = 'ADMIN_SEARCH_TYPES_CLEAR';
export const ADMIN_COMPANY_FORM_FIELDS_LOADED = 'ADMIN_COMPANY_FORM_FIELDS_LOADED';
export const ADMIN_COMPANY_FORM_FIELDS_CLEAR = 'ADMIN_COMPANY_FORM_FIELDS_CLEAR';

// ADMIN - Monetization Requests
export const ADMIN_MONETIZATION_REQUESTS_LOADED = 'ADMIN_MONETIZATION_REQUESTS_LOADED';
export const ADMIN_MONETIZATION_REQUESTS_CLEAR = 'ADMIN_MONETIZATION_REQUESTS_CLEAR';
export const ADMIN_MONETIZATION_REQUEST_DETAILS_LOADED = 'ADMIN_MONETIZATION_REQUEST_DETAILS_LOADED';
export const ADMIN_MONETIZATION_REQUEST_DETAILS_CLEAR = 'ADMIN_MONETIZATION_REQUEST_DETAILS_CLEAR';

// ADMIN - Payouts
export const ADMIN_PAYOUTS_LOADED = 'ADMIN_PAYOUTS_LOADED';
export const ADMIN_PAYOUTS_CLEAR = 'ADMIN_PAYOUTS_CLEAR';
export const ADMIN_CID_PAYOUT_STATUS_LOADED = 'ADMIN_CID_PAYOUT_STATUS_LOADED';
export const ADMIN_CID_PAYOUT_STATUS_CLEAR = 'ADMIN_CID_PAYOUT_STATUS_CLEAR';
export const ADMIN_CID_ANALYTICS_OVERVIEW_LOADED = 'ADMIN_CID_ANALYTICS_OVERVIEW_LOADED';
export const ADMIN_CID_ANALYTICS_CREATOR_GROWTH_LOADED = 'ADMIN_CID_ANALYTICS_CREATOR_GROWTH_LOADED';
export const ADMIN_CID_ANALYTICS_REVENUE_BY_MONTH_LOADED = 'ADMIN_CID_ANALYTICS_REVENUE_BY_MONTH_LOADED';
export const ADMIN_CID_ANALYTICS_REVENUE_RANKS_LOADED = 'ADMIN_CID_ANALYTICS_REVENUE_RANKS_LOADED';
export const ADMIN_CID_ANALYTICS_VIDEO_STATS_LOADED = 'ADMIN_CID_ANALYTICS_VIDEO_STATS_LOADED';
export const ADMIN_CID_ANALYTICS_WEEKLY_GROWTH_LOADED = 'ADMIN_CID_ANALYTICS_WEEKLY_GROWTH_LOADED';
export const ADMIN_CID_ANALYTICS_VIEWS_ANALYTICS_LOADED = 'ADMIN_CID_ANALYTICS_VIEWS_ANALYTICS_LOADED';
export const ADMIN_CID_ANALYTICS_CLAIMS_PERFORMANCE_LOADED = 'ADMIN_CID_ANALYTICS_CLAIMS_PERFORMANCE_LOADED';
export const ADMIN_CID_ANALYTICS_REVENUE_PER_CREATOR_LOADED = 'ADMIN_CID_ANALYTICS_REVENUE_PER_CREATOR_LOADED';
export const ADMIN_CID_ANALYTICS_ESTIMATED_REVENUE_LOADED = 'ADMIN_CID_ANALYTICS_ESTIMATED_REVENUE_LOADED';
export const ADMIN_CID_ANALYTICS_FILTER_OPTIONS_LOADED = 'ADMIN_CID_ANALYTICS_FILTER_OPTIONS_LOADED';
export const ADMIN_CID_ANALYTICS_CLEAR = 'ADMIN_CID_ANALYTICS_CLEAR';
export const ADMIN_CID_ANALYTICS_YT_AUDITS_LOADED = 'ADMIN_CID_ANALYTICS_YT_AUDITS_LOADED';

// CREATOR REFERRALS
export const CREATOR_REFERRALS_LOADED = 'CREATOR_REFERRALS_LOADED';
export const CREATOR_REFERRALS_CLEAR = 'CREATOR_REFERRALS_CLEAR';
export const CREATOR_REFERRAL_INVITE_LINK_LOADED = 'CREATOR_REFERRAL_INVITE_LINK_LOADED';
export const CREATOR_REFERRAL_INVITE_LINK_CLEAR = 'CREATOR_REFERRAL_INVITE_LINK_CLEAR';

// ADMIN - Custom Onboarding (Prefill Link Generator)
export const ADMIN_PREFILL_PRICING_LOADED = 'ADMIN_PREFILL_PRICING_LOADED';
export const ADMIN_PREFILL_PRICING_CLEAR = 'ADMIN_PREFILL_PRICING_CLEAR';
export const ADMIN_PREFILL_ONBOARDING_SUCCESS = 'ADMIN_PREFILL_ONBOARDING_SUCCESS';
export const ADMIN_PREFILL_ONBOARDING_CLEAR = 'ADMIN_PREFILL_ONBOARDING_CLEAR';

// CUSTOMER - Prefill Token Onboarding
export const PREFILL_ONBOARDING_DATA_LOADING = 'PREFILL_ONBOARDING_DATA_LOADING';
export const PREFILL_ONBOARDING_DATA_LOADED = 'PREFILL_ONBOARDING_DATA_LOADED';
export const PREFILL_ONBOARDING_DATA_CLEAR = 'PREFILL_ONBOARDING_DATA_CLEAR';

// OTHER
export const REDIRECT_REQUESTED = 'REDIRECT_REQUESTED';
export const REDIRECT_COMPLETED = 'REDIRECT_COMPLETED';

export const FETCH_LOADER_FINISHED = 'FETCH_LOADER_FINISHED';
export const FETCH_LOADER_LOADING = 'FETCH_LOADER_LOADING';
export const SECONDARY_FETCH_LOADER_FINISHED = 'SECONDARY_FETCH_LOADER_FINISHED';
export const SECONDARY_FETCH_LOADER_LOADING = 'SECONDARY_FETCH_LOADER_LOADING';
export const SUBMISSION_LOADER_FINISHED = 'SUBMISSION_LOADER_FINISHED';
export const SUBMISSION_LOADER_LOADING = 'SUBMISSION_LOADER_LOADING';

export const NOTICE_LOADED = 'NOTICE_LOADED';
export const NOTICE_CLEAR = 'NOTICE_CLEAR';
export const CUSTOM_NOTICE_LOADED = 'CUSTOM_NOTICE_LOADED';
export const CUSTOM_NOTICE_CLEAR = 'CUSTOM_NOTICE_CLEAR';
export const TOUR_STARTED = 'TOUR_STARTED';
export const TOUR_ENDED = 'TOUR_ENDED';

export const FAVICON_CLEAR = 'FAVICON_CLEAR';
export const FAVICON_LOADING = 'FAVICON_LOADING';
export const FAVICON_READY = 'FAVICON_READY';

export const APPLOADER_CLEAR = 'APPLOADER_CLEAR';
export const APPLOADER_READY = 'APPLOADER_READY';

export const APP_CONFIG_LOADING = 'APP_CONFIG_LOADING';
export const APP_CONFIG_SUCCESS = 'APP_CONFIG_SUCCESS';
export const APP_CONFIG_ERROR = 'APP_CONFIG_ERROR';

export const CANCELLATION_STATUS_LOADED = 'CANCELLATION_STATUS_LOADED';

export const PLAN_MANAGEMENT_LOADING = 'PLAN_MANAGEMENT_LOADING';
export const PLAN_MANAGEMENT_LOADED = 'PLAN_MANAGEMENT_LOADED';
export const PLAN_MANAGEMENT_CLEAR = 'PLAN_MANAGEMENT_CLEAR';
export const PLAN_UPGRADE_SUCCESS = 'PLAN_UPGRADE_SUCCESS';
export const PLAN_UPGRADE_CLEAR = 'PLAN_UPGRADE_CLEAR';

export const PAYOUT_STATUS_LOADING = 'PAYOUT_STATUS_LOADING';
export const PAYOUT_STATUS_LOADED = 'PAYOUT_STATUS_LOADED';
export const PAYOUT_STATUS_CLEAR = 'PAYOUT_STATUS_CLEAR';

export const PAYOUT_ACCOUNT_LOADING = 'PAYOUT_ACCOUNT_LOADING';
export const PAYOUT_ACCOUNT_LOADED = 'PAYOUT_ACCOUNT_LOADED';
export const PAYOUT_ACCOUNT_CLEAR = 'PAYOUT_ACCOUNT_CLEAR';

export const ADMIN_ONBOARDINGS_LOADED = 'ADMIN_ONBOARDINGS_LOADED';
export const ADMIN_ONBOARDINGS_CLEAR = 'ADMIN_ONBOARDINGS_CLEAR';
export const ADMIN_ONBOARDING_DETAILS_LOADED = 'ADMIN_ONBOARDING_DETAILS_LOADED';
export const ADMIN_ONBOARDING_DETAILS_CLEAR = 'ADMIN_ONBOARDING_DETAILS_CLEAR';

export const ADMIN_YT_AUDITS_LOADED = 'ADMIN_YT_AUDITS_LOADED';
export const ADMIN_YT_AUDIT_DETAIL_LOADED = 'ADMIN_YT_AUDIT_DETAIL_LOADED';
export const ADMIN_YT_AUDIT_DETAIL_CLEAR = 'ADMIN_YT_AUDIT_DETAIL_CLEAR';
export const ADMIN_YT_AUDIT_USERS_LOADED = 'ADMIN_YT_AUDIT_USERS_LOADED';
export const ADMIN_YT_AUDITS_CLEAR = 'ADMIN_YT_AUDITS_CLEAR';

// NAGRA
export const FETCH_NAGRA_MONITORING_OPERATIONS_REQUEST = 'FETCH_NAGRA_MONITORING_OPERATIONS_REQUEST';
export const FETCH_NAGRA_MONITORING_OPERATIONS_SUCCESS = 'FETCH_NAGRA_MONITORING_OPERATIONS_SUCCESS';
export const FETCH_NAGRA_MONITORING_OPERATIONS_FAILURE = 'FETCH_NAGRA_MONITORING_OPERATIONS_FAILURE';
export const CREATE_NAGRA_MONITORING_OPERATION_REQUEST = 'CREATE_NAGRA_MONITORING_OPERATION_REQUEST';
export const CREATE_NAGRA_MONITORING_OPERATION_SUCCESS = 'CREATE_NAGRA_MONITORING_OPERATION_SUCCESS';
export const CREATE_NAGRA_MONITORING_OPERATION_FAILURE = 'CREATE_NAGRA_MONITORING_OPERATION_FAILURE';
export const END_NAGRA_MONITORING_OPERATION_REQUEST = 'END_NAGRA_MONITORING_OPERATION_REQUEST';
export const END_NAGRA_MONITORING_OPERATION_SUCCESS = 'END_NAGRA_MONITORING_OPERATION_SUCCESS';
export const END_NAGRA_MONITORING_OPERATION_FAILURE = 'END_NAGRA_MONITORING_OPERATION_FAILURE';
export const FETCH_NAGRA_CANDIDATE_REQUEST = 'FETCH_NAGRA_CANDIDATE_REQUEST';
export const FETCH_NAGRA_CANDIDATE_SUCCESS = 'FETCH_NAGRA_CANDIDATE_SUCCESS';
export const FETCH_NAGRA_CANDIDATE_FAILURE = 'FETCH_NAGRA_CANDIDATE_FAILURE';
export const UPDATE_NAGRA_CANDIDATE_REQUEST = 'UPDATE_NAGRA_CANDIDATE_REQUEST';
export const UPDATE_NAGRA_CANDIDATE_SUCCESS = 'UPDATE_NAGRA_CANDIDATE_SUCCESS';
export const UPDATE_NAGRA_CANDIDATE_FAILURE = 'UPDATE_NAGRA_CANDIDATE_FAILURE';
export const UPLOAD_NAGRA_SCREENSHOT_REQUEST = 'UPLOAD_NAGRA_SCREENSHOT_REQUEST';
export const UPLOAD_NAGRA_SCREENSHOT_SUCCESS = 'UPLOAD_NAGRA_SCREENSHOT_SUCCESS';
export const UPLOAD_NAGRA_SCREENSHOT_FAILURE = 'UPLOAD_NAGRA_SCREENSHOT_FAILURE';
export const SUBMIT_NAGRA_CANDIDATE_REQUEST = 'SUBMIT_NAGRA_CANDIDATE_REQUEST';
export const SUBMIT_NAGRA_CANDIDATE_SUCCESS = 'SUBMIT_NAGRA_CANDIDATE_SUCCESS';
export const SUBMIT_NAGRA_CANDIDATE_FAILURE = 'SUBMIT_NAGRA_CANDIDATE_FAILURE';
export const FETCH_NAGRA_MANUAL_CANDIDATES_REQUEST = 'FETCH_NAGRA_MANUAL_CANDIDATES_REQUEST';
export const FETCH_NAGRA_MANUAL_CANDIDATES_SUCCESS = 'FETCH_NAGRA_MANUAL_CANDIDATES_SUCCESS';
export const FETCH_NAGRA_MANUAL_CANDIDATES_FAILURE = 'FETCH_NAGRA_MANUAL_CANDIDATES_FAILURE';
export const CREATE_NAGRA_MANUAL_CANDIDATE_REQUEST = 'CREATE_NAGRA_MANUAL_CANDIDATE_REQUEST';
export const CREATE_NAGRA_MANUAL_CANDIDATE_SUCCESS = 'CREATE_NAGRA_MANUAL_CANDIDATE_SUCCESS';
export const CREATE_NAGRA_MANUAL_CANDIDATE_FAILURE = 'CREATE_NAGRA_MANUAL_CANDIDATE_FAILURE';
export const FETCH_NAGRA_CANDIDATES_REQUEST = 'FETCH_NAGRA_CANDIDATES_REQUEST';
export const FETCH_NAGRA_CANDIDATES_SUCCESS = 'FETCH_NAGRA_CANDIDATES_SUCCESS';
export const FETCH_NAGRA_CANDIDATES_FAILURE = 'FETCH_NAGRA_CANDIDATES_FAILURE';
export const FETCH_NAGRA_BATCH_REQUEST = 'FETCH_NAGRA_BATCH_REQUEST';
export const FETCH_NAGRA_BATCH_SUCCESS = 'FETCH_NAGRA_BATCH_SUCCESS';
export const FETCH_NAGRA_BATCH_FAILURE = 'FETCH_NAGRA_BATCH_FAILURE';
export const REMOVE_NAGRA_BATCH_CANDIDATE = 'REMOVE_NAGRA_BATCH_CANDIDATE';
